enum UserSetting {
  BULK_EMAIL = "bulkEmail",
  DISTANCE_UNIT = "distanceUnit",
  EMAIL_NOTIFICATION_SETTINGS = "emailNotificationSettings",
  LANGUAGE = "language",
  WEEKLY_REPORT = "weeklyReport",
  WEEKLY_REPORT_SCHEDULE = "weeklyReportSchedule",
}

export default UserSetting;
